var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-12 col-lg-8" },
        [
          _c("div", { ref: "videoWrapper", staticClass: "video-wrapper" }, [
            _c("div", { ref: "player" }),
            _vm._v(" "),
            !_vm.isYoutubeVideo
              ? _c("iframe", {
                  ref: "iframe",
                  attrs: {
                    src: _vm.video.url,
                    frameborder: "0",
                    allow:
                      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowfullscreen: "",
                    referrerpolicy: "strict-origin-when-cross-origin"
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "video-title" }, [
            _vm._v(_vm._s(_vm.video.title))
          ]),
          _vm._v(" "),
          _c("video-header", {
            attrs: { category: _vm.category, video: _vm.video },
            on: { handleLikeVideo: _vm.handleLikeVideo }
          }),
          _vm._v(" "),
          _c("video-description", {
            staticClass: "mr-b-10",
            attrs: { video: _vm.video },
            on: { seekTo: _vm.handleSeek }
          }),
          _vm._v(" "),
          !_vm.video.enableLiveChat
            ? _c("h3", { staticClass: "font-bold" }, [
                _vm._v(_vm._s(_vm.video.comments) + " 件のコメント")
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.video.enableLiveChat
            ? _c(
                "div",
                {
                  ref: "videoCommentsWrapper",
                  staticClass: "video-comments-wrapper"
                },
                [
                  _c("video-comments", {
                    attrs: {
                      video: _vm.video,
                      comments: _vm.comments,
                      sellerId: _vm.sellerId
                    },
                    on: {
                      submitComment: _vm.submitComment,
                      updateComment: _vm.updateComment,
                      handleLikeComment: _vm.handleLikeComment,
                      submitReply: _vm.submitReply,
                      seekTo: _vm.handleSeek
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("related-videos", {
        ref: "relatedVideos",
        staticClass: "col-sm-12 col-md-12 col-lg-4",
        attrs: { videos: _vm.videos, categoryId: _vm.categoryId },
        on: {
          openUpgradePlanModal: function($event) {
            _vm.$emit("openUpgradePlanModal")
          },
          handleClickViewVideo: function($event) {
            _vm.$emit("handleClickViewVideo", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bd93eb7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bd93eb7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/video/VideoPlayer.vue
// module id = null
// module chunks = 